import React, { useEffect, useState } from "react";
import { Route, withRouter } from "react-router-dom";
// import { logout } from "../../redux/actions/login";
import Navbar from "./shared/navbar";
import Sidebar from "./shared/sidebar";
import Footer from "./shared/footer";

import { useDispatch } from "react-redux";
import "../../components/pages/dashboard/dashboard.css";
import "./shared/shared.css";
import Cookie from "../../lib/cookie";
import { decrypt, setEncryptedItem } from "../../helper/methods";

const PrivateRoute = ({ component: Component, restricted, ...rest }, props) => {
  let dispatch = useDispatch();
  let cookie = new Cookie();
  // let disType = cookie.getCookie("distype");
  const [option, setOption] = useState([
    //  { menu: { label: 'Dashboard', absolutePath: true, linkTo: `/`, class: "myportfolio_navicon" }, },
    {
      menu: {
        label: "Investors Report",
        linkTo: `/report`,
        class: "report_navicon",
      },
    },
    {
      menu: {
        label: "My Report",
        linkTo: ``,
        class: "report_navicon",
        type: "a",
      },
      subMenu: [
        {
          menu: { label: "Aum Mis", linkTo: `/myreports/aumMis`, class: "xyz" },
        },
        {
          menu: {
            label: "Flow in flow out",
            linkTo: `/myreports/flowInFlowOut`,
            class: "xyz",
          },
        },
      ],
    },
    {
      menu: {
        label: "Checklist",
        linkTo: ``,
        class: "orderbook_navicon",
        type: "a",
      },
      subMenu: [
        {
          menu: {
            label: "PMS Account Opening",
            linkTo: `/checklist`,
            class: "xyz",
          },
        },
        { menu: { label: "Redemption", linkTo: `/redemption`, class: "xyz" } },
      ],
    },
  ]);
  const [option1, setOption1] = useState([
    // { menu: { label: 'Dashboard', linkTo: `/business-dashboard`, class: "myportfolio_navicon" }, },
    {
      menu: {
        label: "Onboard Investor",
        linkTo: `https://digiaif.motilaloswalamc.com/login`,
        class: "newFolio_navicon",
        url: true,
      },
    },
    { menu: { label: "Report", linkTo: `/report`, class: "report_navicon" } },
    {
      menu: { label: "Feedback", url: true, linkTo: `https://forms.gle/ky41ZQ6mCc9HfLEn7`, class: "feedback_navicon" },
    },
    {
      menu: { label: "Contact Us", linkTo: `/feedback`, class: "feedback_navicon" },
    },    
  ]);

  const [disType, setDistype] = useState(cookie.getCookie('distype'));

  useEffect(() => {
    // Listen for cookie change event
    const cookieChangeHandler = () => {
      setDistype(cookie.getCookie('distype'));
    };
    window.addEventListener('cookieChanged', cookieChangeHandler);
    // Cleanup: Remove event listener on component unmount
    return () => {
      window.removeEventListener('cookieChanged', cookieChangeHandler);
    };
  }, []);
  
  const urlParams = new URLSearchParams(window.location.search);
  let ARNCode;
  let productDtls;
  let uniqueKey;
  let redirectDitUrl;
  let onlyProductNames;
  let loginWithFromLS;
  let userIdFromLS;

  const encryptedParams = urlParams.get('encryptedParams');
  console.log("checking at line 71: ", urlParams);

  if (encryptedParams) {
    try {
      const decryptedParams = decrypt(decodeURIComponent(encryptedParams), process.env.REACT_APP_ENC_KEY);
      const params = JSON.parse(decryptedParams);
      console.log("Decrypted Params:", params);
      ARNCode = params?.arnCode;
      productDtls = params?.productDtls;
      uniqueKey = params?.uniqueKey;
      redirectDitUrl = params?.redirectDitUrl;
      onlyProductNames = params?.onlyProductNames;
      loginWithFromLS = params?.loginWithFromLS;
      userIdFromLS = params?.userIdFromLS;
  
      if (productDtls !== null) {
        localStorage.setItem("ARNCode", ARNCode);
        setEncryptedItem("productDtls", productDtls);
        setEncryptedItem("uniqueKey", uniqueKey);
        localStorage.setItem("redirectDitUrl", redirectDitUrl);
        localStorage.setItem("onlyProductNames", onlyProductNames);
        localStorage.setItem("LoginTypeentered", loginWithFromLS);
        localStorage.setItem("PANentered", userIdFromLS);
      }
  
    } catch (error) {
      console.error("Error decrypting the parameters:", error);
    }
  } else {
    console.error("No encrypted parameters found in the URL.");
  }


  let locationPath = rest.location.pathname; // currentUrl e.g. /dashboard/systematicPlan, /dashboard/transcat/invest

  const addDit = (arr, newValue) => {
    const found = arr.some((el) => el.menu.label === newValue.menu.label);
    if (!found) arr.push(newValue);
    return arr;
  };

  const logoutClick = () => {
    // dispatch(logout())
  };

  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <React.Fragment>
      <div className="container-scroller">
        <Navbar logout={logoutClick} disTypeFromPR={disType}/>

        <div className="container-fluid page-body-wrapper">
          {disType === "PMS" ? (
            <Sidebar option={option} />
          ) : (
            <Sidebar option={option1} ARNCode={ARNCode} productDtls={productDtls} redirectDitUrl={redirectDitUrl} onlyProductNames={onlyProductNames} uniqueKey={uniqueKey}/>
          )}
          <div className="main-panel">
            <div className="content-wrapper">
              <Route
                {...rest}
                render={(props) => <Component {...props} {...rest} />}
              />
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(PrivateRoute);
